export interface MonthRange {
    start: number
    end: number
    month: string
}

/**
 * Get months range to one year back
 *
 * @return {MonthRange[]}
 */
export const getMonthsRange = (): MonthRange[] => {
    const months: MonthRange[] = []
    const currentDate = new Date()

    // Iterujeme přes posledních 12 měsíců
    for (let i = 0; i < 13; i++) {
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1)
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - i + 1, 0, 23, 59, 59, 999)

        const monthObject: MonthRange = {
            start: firstDayOfMonth.getTime(),
            end: lastDayOfMonth.getTime(),
            month: getMonthName(firstDayOfMonth.getMonth()) + ' ' + firstDayOfMonth.getFullYear(),
        }

        months.push(monthObject)
    }

    return months
}

function getMonthName(monthIndex: number): string {
    const months: string[] = [
        'leden', 'únor', 'březen', 'duben',
        'květen', 'červen', 'červenec', 'srpen',
        'září', 'říjen', 'listopad', 'prosinec',
    ]

    return months[monthIndex]
}
